import { Component, ViewEncapsulation } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-coro-nav-feature-card-grid',
    templateUrl: './coro-nav-feature-card-grid.component.html',
    styleUrl: './coro-nav-feature-card-grid.component.scss',
    standalone: false,
    encapsulation: ViewEncapsulation.None,
})
export class CoroNavFeatureCardGridComponent extends BlockAbstractComponent {
    getImageUrl(url: string) {
        return APP_CONFIG.frontend + url;
    }
}
